import type { RawEditorOptions } from 'tinymce';

export const RICH_TEXT_EDITOR_INIT: RawEditorOptions = {
    license_key: 'gpl',
    promotion: false,
    branding: false,
    menubar: false,
    statusbar: false,
    min_height: 200,
    max_height: 400,
    resize: true,
    plugins: 'lists link directionality autoresize',
    toolbar:
        'bold italic underline strikethrough | blocks fontfamily | forecolor backcolor | ' +
        'bullist numlist | outdent indent | alignleft aligncenter alignright alignjustify | ' +
        'subscript superscript | blockquote | ltr rtl | link | removeformat',
    block_formats: 'Paragraph=p; Heading 1=h1; Heading 2=h2; Heading 3=h3; Heading 4=h4; Heading 5=h5; Heading 6=h6; Preformatted=pre',
    relative_urls: false,
    remove_script_host: false,
    link_default_target: '_blank',
    link_assume_external_targets: true
};

export const RICH_TEXT_LIST_CSS =
    'ul:not([class]){list-style-type:disc;margin:0.5em 0;padding-left:2em}' +
    'ol:not([class]){list-style-type:decimal;margin:0.5em 0;padding-left:2em}' +
    'ul:not([class]) ul:not([class]){list-style-type:circle}' +
    'ul:not([class]) ul:not([class]) ul:not([class]){list-style-type:square}' +
    'li:not([class]){display:list-item}';
